import { useEffect, useState } from 'react';

// transient AquaFlow results shared between the panel, the 2D map layer and the 3D view
let st = { res: null, th: null, mode: 'p', on: false };
const subs = new Set();
export const aquaState = () => st;
if (typeof window !== 'undefined') window.__gissAquaState = aquaState; // read-only hook for reviewers / automated reference checks
export const setAqua = (p) => { st = { ...st, ...p }; subs.forEach((f) => f(st)); };
export function useAqua() {
  const [s, set] = useState(st);
  useEffect(() => { subs.add(set); return () => subs.delete(set); }, []);
  return s;
}
export const openAqua = (tab) => window.dispatchEvent(new CustomEvent('giss-aqua-open', { detail: tab || null }));
